/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
/**
 * Advanced mapped types collection.
 * https://www.typescriptlang.org/docs/handbook/advanced-types.html#mapped-types
 */

/**
 * Require that specified (possibly nullable) fields of T are set.
 * The rest of the fields preserve nullable modifiers.
 *
 * Note: Private fields are not accessible to mapped types.
 */
type Require<T, K extends keyof T> = T & { [P in K]: NonNullable<T[P]> };

/**
 * Require that specified fields of T are set. The rest of the fields are optional.
 *
 * Note: Private fields are not accessible to mapped types.
 */
type RequireOnly<T, K extends keyof T> = Partial<T> & { [P in K]: NonNullable<T[P]> };

export { Require, RequireOnly };
